import { convertKlevuProductData, sendRecsAnalyticsEvent } from '../utils/klevu'

export default ({ 
    configurationId,
    productId,
    productVariantId,
    collectionTitle,
    excludedProductIds,
    dispatchEventWhenFinished = false
}) => ({
    configuration: null,
    title: '',
    products: [],
    recsKey: '',
    recsLogic: '',

    async init() {
        if (!configurationId) {
            throw new Error('Configuration ID not provided.')
        }

        this.configuration = await this.fetchConfiguration()
        this.title = this.configuration.metadata.title

        const recommendationsData = await this.fetchRecommendations()
        const productResults = recommendationsData?.queryResults[0]?.records ?? []

        if (productResults.length) {
            const meta = recommendationsData?.queryResults[0]?.meta ?? {}
            this.recsKey = meta.recsKey ?? configurationId
            this.recsLogic = meta.logic ?? this.configuration.metadata?.logic ?? ''

            this.products = await convertKlevuProductData(recommendationsData?.queryResults[0]?.records)

            this.sendImpressionEvent()

            if (dispatchEventWhenFinished) {
                this.$dispatch('smart-recs-loaded', configurationId)
            }
        } else {
            console.error('No smart recommendations results received')
        }
    },

    sendImpressionEvent() {
        const items = this.products.map((product, i) => ({
            item_id: product.id,
            item_group_id: product.itemGroupId,
            item_variant_id: product.id,
            item_name: product.name,
            price: (product.salePrice || product.price) / 100,
            index: i + 1,
        }))
        sendRecsAnalyticsEvent('view_recs_list', this.recsKey, this.title, this.recsLogic, items)
    },

    handleProductClick(event, product) {
        event.preventDefault()
        const index = this.products.findIndex(p => p.id === product.id)
        const items = [{
            item_id: product.id,
            item_group_id: product.itemGroupId,
            item_variant_id: product.id,
            item_name: product.name,
            price: (product.salePrice || product.price) / 100,
            index: index + 1,
        }]
        sendRecsAnalyticsEvent('select_recs_list', this.recsKey, this.title, this.recsLogic, items)
            .finally(() => { window.location = product.url })
    },

    async fetchConfiguration() {
        let url = `https://config-cdn.ksearchnet.com/recommendations/${shopifyData.klevuApi.key}/settings/${configurationId}`

        if (productVariantId) {
            url = `${url}?pid=${encodeURIComponent(productVariantId)}`
        }

        if (collectionTitle) {
            url = `${url}?cp=${encodeURIComponent(collectionTitle)}`
        }

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {}
            })

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`)
            }

            const json = await response.json()

            return json
        } catch (error) {
            console.error(error.message)
        }
    },
    async fetchRecommendations() {
        const url = `https://${this.configuration.search.basePath}`
        console.log('Fetching recommendations with configuration:', this.configuration)

        const requestBody = {
            context: {
                apiKeys: [shopifyData.klevuApi.key]
            },
            ...JSON.parse(this.configuration.search.payload),
        }

        requestBody.recordQueries[0].settings = requestBody.recordQueries[0].settings || {}

        requestBody.recordQueries[0].settings.fields = [
            'id',
            'itemGroupId',
            'name',
            'price',
            'salePrice',
            'url',
            'image',
            'imageHover',
            'additionalDataToReturn',
        ]

        if (productId || productVariantId) {
            requestBody.recordQueries[0].settings.excludeIds = [
                {
                    key: "itemGroupId",
                    value: productId
                }
            ]

            requestBody.recordQueries[0].settings.context = {
                recentObjects: [
                    {
                        typeOfRecord: 'KLEVU_PRODUCT',
                        records: [
                            { id: productVariantId }
                        ]
                    }
                ]
            }
        }

        if (collectionTitle) {
            requestBody.recordQueries[0].settings.query = {
                categoryPath: collectionTitle
            }
        }

        if (excludedProductIds) {
            const excludedProducts = excludedProductIds.map(id => ({
                key: "itemGroupId",
                value: id.toString()
            }))

            if (requestBody.recordQueries[0].settings.excludeIds) {
                requestBody.recordQueries[0].settings.excludeIds = requestBody.recordQueries[0].settings.excludeIds.concat(excludedProducts)
            } else {
                requestBody.recordQueries[0].settings.excludeIds = excludedProducts
            }
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`)
            }

            const json = await response.json()

            return json
        } catch (error) {
            console.error(error.message)
        }
    }
})
